import { request } from '../../helpers/apiHelper'
import { decodeRefiTransaction } from './queries/decoders/decodeRefiTransaction'
import { displayNotification } from '../../actions/notificationsActions'
import {
  refiTransactionsQuery,
  refiTransactionQuery,
  refiTransactionTodosQuery,
} from './queries'

export enum RefiActionType {
  FETCH_REFITRANSACTIONS_SUCCESS = 'FETCH_REFITRANSACTIONS_SUCCESS',
  FETCH_REFITRANSACTIONS_FAILURE = 'FETCH_REFITRANSACTIONS_FAILURE',
  FETCH_REFITRANSACTION_SUCCESS = 'FETCH_REFITRANSACTION_SUCCESS',
  FETCH_REFITRANSACTION_FAILURE = 'FETCH_REFITRANSACTION_FAILURE',
  FETCH_REFITODOS_SUCCESS = 'FETCH_REFITODOS_SUCCESS',
  FETCH_REFITODOS_FAILURE = 'FETCH_REFITODOS_FAILURE',
}

export interface RefiAction {
  type: RefiActionType
  entities?: any
  entity?: any
  meta?: any
}

export const fetchRefiTransactions = (varObject) => (dispatch) => {
  return request(refiTransactionsQuery.default, varObject)
    .then((response) => {
      dispatch({
        type: RefiActionType.FETCH_REFITRANSACTIONS_SUCCESS,
        entities: response.data.data.refis.items,
        meta: response.data.data.refis.meta,
      })
    })
    .catch(() => {
      dispatch({
        type: RefiActionType.FETCH_REFITRANSACTIONS_FAILURE,
      })
      dispatch(
        displayNotification(
          'Failed to fetch Refinance Transactions',
          'error',
          10000
        )
      )
    })
}

export const fetchRefiTransaction = (id) => (dispatch) => {
  return request(refiTransactionQuery.default, { id })
    .then((response) => {
      const refiTransaction = decodeRefiTransaction(response.data.data.refi)
      dispatch({
        type: RefiActionType.FETCH_REFITRANSACTION_SUCCESS,
        entity: refiTransaction,
      })

      return refiTransaction
    })
    .catch(() => {
      dispatch({
        type: RefiActionType.FETCH_REFITRANSACTION_FAILURE,
      })
      dispatch(displayNotification('Failed to fetch Refi Transaction', 'error'))
    })
}

export const fetchRefiTransactionTodos = (id: string) => (dispatch) => {
  return request(refiTransactionTodosQuery.default, { id })
    .then((response) => {
      const refiTodos = response.data.data.refi
      dispatch({
        type: RefiActionType.FETCH_REFITODOS_SUCCESS,
        entity: refiTodos,
      })
    })
    .catch(() => {
      dispatch({
        type: RefiActionType.FETCH_REFITODOS_FAILURE,
      })
      dispatch(
        displayNotification('Failed to fetch Refi Transaction Todos', 'error')
      )
    })
}
